import clsx from 'clsx';
import React from 'react';
const UpdatePaymentFlowFormLabel = ({ className, labelText = 'Add another payment method' }) => {
    return (React.createElement("div", { className: clsx('mb-5', className) },
        React.createElement("span", { className: "font-semibold text-base text-grey-70" }, labelText)));
};
export default UpdatePaymentFlowFormLabel;
